import { defineMessages } from "../i18n/core";

export const settingsMessages = defineMessages({
  "pt-BR": {
    tabNotifications: "Notificações",
    tabCredentials: "Credenciais",
    notificationsSub: "Alertas são enviados quando abrem e quando se resolvem, nunca repetidos a cada verificação.",
    emailUnavailable: "O envio de e-mail não está configurado neste servidor. Webhooks continuam disponíveis.",
    newChannel: "Novo canal",
    editChannel: (name: string) => `Editar ${name}`,
    noChannels: "Nenhum canal de notificação ainda. Sem canais, os alertas aparecem só na console.",
    kind: "Tipo",
    kindEmail: "E-mail",
    kindWebhook: "Webhook",
    destination: "Destino",
    minSeverity: "Gravidade",
    severityWarning: "Avisos e críticos",
    severityCritical: "Só críticos",
    channelLanguage: "Idioma",
    channelEnabled: "Ativo",
    channelDisabled: "Pausado",
    lastDelivery: "Última entrega",
    channelLastError: (msg: string) => `Última entrega falhou: ${msg}`,
    testChannel: "Testar",
    testSent: "Notificação de teste entregue.",
    deleteChannelLabel: (name: string) => `Remover o canal ${name}`,
    deleteChannelTitle: (name: string) => `Remover o canal ${name}?`,
    deleteChannelDescription: "Notificações pendentes deste canal são descartadas. Os alertas continuam visíveis na console.",
    channelDeleted: "Canal removido.",
    channelSaved: "Canal salvo.",
    channelName: "Nome",
    channelNamePlaceholder: "Equipe de suporte",
    emailsLabel: "E-mails",
    emailsHint: "Um por linha ou separados por vírgula, até 20.",
    webhookUrl: "Endereço do webhook",
    webhookUrlHint: "Precisa ser https://. O servidor não segue redirecionamentos.",
    enabledLabel: "Canal ativo",
    monthlySummaryLabel: "Enviar o resumo mensal de proteção",
    monthlySummaryHint: "No dia 1º, o resumo do mês anterior chega por e-mail com o relatório em PDF/A anexo. O botão de relatório na lista envia agora, para validar.",
    monthlySummaryTag: "Resumo mensal",
    sendSummary: (name: string) => `Enviar agora o resumo do mês anterior por ${name}`,
    summarySent: "Resumo mensal enviado. A emissão está em Relatórios.",
    webhookSecretTitle: "Guarde o segredo do webhook",
    webhookSecretHint: "Este segredo aparece só agora. Use-o para conferir que as chamadas vêm do E-BACKUP.",
    webhookSecretLabel: "segredo do webhook",
    webhookVerify: "Cada chamada traz X-EBackup-Timestamp e X-EBackup-Signature. A assinatura é sha256= seguido do HMAC-SHA256, com este segredo, de timestamp + \".\" + corpo. Recuse chamadas com timestamp antigo.",
    title: "Configurações",
    lede: "Acesso à console e à API, e a trilha de auditoria desta organização.",
    accountTitle: "Sua conta",
    languageHint: "Fica salvo na sua conta e vale em qualquer navegador.",
    passwordLabel: "Senha",
    passwordHint: "Ao trocar, as outras sessões abertas com a sua conta são encerradas.",
    changePassword: "Trocar senha",
    currentPassword: "Senha atual",
    newPassword: "Nova senha",
    newPasswordHint: "De 12 a 256 caracteres. Uma frase longa é mais segura que uma senha curta complicada.",
    confirmPassword: "Repita a nova senha",
    mismatch: "As senhas não conferem.",
    code: "Código do autenticador",
    passwordChanged: "Senha trocada. As outras sessões foram encerradas.",
    nameHint: "Aparece para as pessoas das suas organizações e na trilha de auditoria.",
    editName: "Alterar nome",
    nameSaved: "Nome salvo.",
    emailHint: "Usado para entrar e para redefinir a senha. A troca exige a senha atual e o código do autenticador.",
    changeEmail: "Trocar e-mail",
    changeEmailDescription: "Confirme com a senha atual e o código do autenticador. Se este servidor envia e-mails, a troca só vale depois que você abrir o link enviado ao novo endereço.",
    newEmail: "Novo e-mail",
    emailPendingTitle: "Confirme o novo e-mail",
    emailPending: (email: string) => `Enviamos um link de confirmação para ${email}. A troca só vale depois que você abrir o link, que expira em 1 hora. Até lá, continue entrando com o e-mail atual.`,
    emailPendingNotice: "O endereço atual também recebeu um aviso sobre este pedido.",
    emailChanged: (email: string) => `E-mail trocado para ${email}.`,
    mockConfirmEmail: "Abrir o link de confirmação (mock)",
    actionFailed: "Não foi possível concluir. Tente de novo.",
    tabs: "Configurações",
    tabUsers: "Usuários",
    tabApi: "Tokens de API",
    tabAudit: "Auditoria",
    usersSub: "Toda conta usa verificação em duas etapas.",
    invite: "Convidar pessoa",
    inviteDescription: "A pessoa recebe um link de uso único, válido por 72 horas, para criar a conta com verificação em duas etapas.",
    email: "E-mail",
    name: "Nome",
    role: "Papel",
    roleHint: {
      org_admin: "Tudo, inclusive pessoas, políticas e tokens de API.",
      operator: "Dispara backups e restaurações; não altera configurações.",
      viewer: "Só consulta.",
    },
    createInvite: "Criar convite",
    inviteCreatedTitle: "Convite criado",
    inviteLinkHint: (email: string) => `Envie este link para ${email} por um canal seguro. Ele aparece só agora e vale por 72 horas.`,
    inviteLinkLabel: "link do convite",
    done: "Concluir",
    pendingTitle: "Convites pendentes",
    expiresIn: (when: string) => `vence ${when}`,
    invitedBy: (who: string) => `convidado por ${who}`,
    revoke: "Revogar",
    invitationRevoked: "Convite revogado.",
    colName: "Nome",
    colRole: "Papel",
    colTwoStep: "Duas etapas",
    colLastLogin: "Último acesso",
    inherited: "herdado do MSP",
    you: "você",
    twoStepOn: "Ativa",
    twoStepPending: "Autenticador pendente",
    actions: "Ações",
    resetTotpLabel: (name: string) => `Redefinir a verificação em duas etapas de ${name}`,
    resetTotpTitle: (name: string) => `Redefinir a verificação em duas etapas de ${name}?`,
    resetTotpDescription: "Use quando a pessoa perdeu ou trocou o celular. Antes, confirme a identidade dela por um canal que você conhece.",
    resetTotpSessions: "Todas as sessões abertas da pessoa são encerradas na hora, em qualquer navegador.",
    resetTotpNextLogin: "No próximo acesso, depois da senha, ela vê um QR code para cadastrar um autenticador novo.",
    resetTotpPassword: "A senha dela não muda, e você não ganha acesso à conta.",
    resetTotpConfirm: "Redefinir",
    totpResetDone: (name: string) => `Verificação em duas etapas de ${name} redefinida. No próximo acesso, a pessoa cadastra um autenticador novo.`,
    changeRoleLabel: (name: string) => `Papel de ${name}`,
    roleChanged: (name: string) => `Papel de ${name} alterado.`,
    remove: "Remover",
    removeLabel: (name: string) => `Remover o acesso de ${name}`,
    removeTitle: (name: string) => `Remover o acesso de ${name}?`,
    removeDescription: "A pessoa perde o acesso a esta organização na hora. A conta continua existindo e pode ser convidada de novo.",
    removed: (name: string) => `Acesso de ${name} removido.`,
    apiSub: "Para integrações com RMM, PSA e scripts. O token completo aparece uma única vez.",
    createToken: "Criar token",
    tokenName: "Nome",
    tokenNameHint: "Onde o token será usado. Por exemplo: RMM da matriz.",
    tokenDefaultName: "Integração",
    validity: "Validade",
    days: (n: number) => `${n} dias`,
    tokenCreatedTitle: "Guarde o token agora",
    tokenSecretHint: "Este é o único momento em que o token completo aparece. Guarde-o num cofre de senhas.",
    tokenSecretLabel: "token de API",
    tokenUsage: "Use no cabeçalho de cada requisição:",
    colPrefix: "Prefixo",
    colCreatedBy: "Criado por",
    colLastUsed: "Último uso",
    colExpires: "Vence",
    expired: "Vencido",
    noTokens: "Nenhum token de API ainda.",
    revokeTokenLabel: (name: string) => `Revogar o token ${name}`,
    revokeTokenTitle: (name: string) => `Revogar o token ${name}?`,
    revokeTokenDescription: "Integrações que usam este token param de funcionar na hora.",
    tokenRevoked: "Token revogado.",
    colWhen: "Quando",
    colWho: "Quem",
    colWhat: "O quê",
    colTarget: "Alvo",
    colIp: "IP",
  },
  "en-US": {
    tabNotifications: "Notifications",
    tabCredentials: "Credentials",
    notificationsSub: "Alerts are sent when they open and when they resolve, never repeated on every check.",
    emailUnavailable: "Email is not configured on this server. Webhooks are still available.",
    newChannel: "New channel",
    editChannel: (name: string) => `Edit ${name}`,
    noChannels: "No notification channels yet. Without channels, alerts only show in the console.",
    kind: "Type",
    kindEmail: "Email",
    kindWebhook: "Webhook",
    destination: "Destination",
    minSeverity: "Severity",
    severityWarning: "Warnings and critical",
    severityCritical: "Critical only",
    channelLanguage: "Language",
    channelEnabled: "Active",
    channelDisabled: "Paused",
    lastDelivery: "Last delivery",
    channelLastError: (msg: string) => `Last delivery failed: ${msg}`,
    testChannel: "Test",
    testSent: "Test notification delivered.",
    deleteChannelLabel: (name: string) => `Remove channel ${name}`,
    deleteChannelTitle: (name: string) => `Remove channel ${name}?`,
    deleteChannelDescription: "Pending notifications for this channel are discarded. Alerts remain visible in the console.",
    channelDeleted: "Channel removed.",
    channelSaved: "Channel saved.",
    channelName: "Name",
    channelNamePlaceholder: "Support team",
    emailsLabel: "Emails",
    emailsHint: "One per line or comma-separated, up to 20.",
    webhookUrl: "Webhook address",
    webhookUrlHint: "Must be https://. The server does not follow redirects.",
    enabledLabel: "Channel active",
    monthlySummaryLabel: "Send the monthly protection summary",
    monthlySummaryHint: "On the 1st, last month's summary arrives by email with the PDF/A report attached. The report button in the list sends it now, to validate.",
    monthlySummaryTag: "Monthly summary",
    sendSummary: (name: string) => `Send last month's summary now through ${name}`,
    summarySent: "Monthly summary sent. The issue is listed under Reports.",
    webhookSecretTitle: "Save the webhook secret",
    webhookSecretHint: "This secret is shown only now. Use it to verify that calls come from E-BACKUP.",
    webhookSecretLabel: "webhook secret",
    webhookVerify: "Each call carries X-EBackup-Timestamp and X-EBackup-Signature. The signature is sha256= followed by the HMAC-SHA256, with this secret, of timestamp + \".\" + body. Reject calls with an old timestamp.",
    title: "Settings",
    lede: "Console and API access, and this organization's audit trail.",
    accountTitle: "Your account",
    languageHint: "Saved to your account and applied on any browser.",
    passwordLabel: "Password",
    passwordHint: "Changing it signs out your other open sessions.",
    changePassword: "Change password",
    currentPassword: "Current password",
    newPassword: "New password",
    newPasswordHint: "12 to 256 characters. A long passphrase is safer than a short complicated password.",
    confirmPassword: "Repeat the new password",
    mismatch: "The passwords do not match.",
    code: "Authenticator code",
    passwordChanged: "Password changed. Your other sessions were signed out.",
    nameHint: "Shown to people in your organizations and in the audit trail.",
    editName: "Change name",
    nameSaved: "Name saved.",
    emailHint: "Used to sign in and to reset your password. Changing it requires your current password and authenticator code.",
    changeEmail: "Change email",
    changeEmailDescription: "Confirm with your current password and authenticator code. If this server sends email, the change only applies after you open the link sent to the new address.",
    newEmail: "New email",
    emailPendingTitle: "Confirm your new email",
    emailPending: (email: string) => `We sent a confirmation link to ${email}. The change only applies after you open the link, which expires in 1 hour. Until then, keep signing in with your current email.`,
    emailPendingNotice: "Your current address also received a notice about this request.",
    emailChanged: (email: string) => `Email changed to ${email}.`,
    mockConfirmEmail: "Open the confirmation link (mock)",
    actionFailed: "Could not complete. Try again.",
    tabs: "Settings",
    tabUsers: "Users",
    tabApi: "API tokens",
    tabAudit: "Audit",
    usersSub: "Every account uses two-step verification.",
    invite: "Invite person",
    inviteDescription: "The person gets a single-use link, valid for 72 hours, to create an account with two-step verification.",
    email: "Email",
    name: "Name",
    role: "Role",
    roleHint: {
      org_admin: "Everything, including people, policies and API tokens.",
      operator: "Runs backups and restores; cannot change settings.",
      viewer: "Read only.",
    },
    createInvite: "Create invitation",
    inviteCreatedTitle: "Invitation created",
    inviteLinkHint: (email: string) => `Send this link to ${email} over a secure channel. It is shown only now and is valid for 72 hours.`,
    inviteLinkLabel: "invitation link",
    done: "Done",
    pendingTitle: "Pending invitations",
    expiresIn: (when: string) => `expires ${when}`,
    invitedBy: (who: string) => `invited by ${who}`,
    revoke: "Revoke",
    invitationRevoked: "Invitation revoked.",
    colName: "Name",
    colRole: "Role",
    colTwoStep: "Two-step",
    colLastLogin: "Last sign-in",
    inherited: "inherited from MSP",
    you: "you",
    twoStepOn: "On",
    twoStepPending: "Authenticator pending",
    actions: "Actions",
    resetTotpLabel: (name: string) => `Reset two-step verification for ${name}`,
    resetTotpTitle: (name: string) => `Reset two-step verification for ${name}?`,
    resetTotpDescription: "Use this when the person lost or replaced their phone. First, confirm who they are through a channel you trust.",
    resetTotpSessions: "All of their open sessions are signed out immediately, in every browser.",
    resetTotpNextLogin: "On their next sign-in, after the password, they see a QR code to register a new authenticator.",
    resetTotpPassword: "Their password does not change, and you do not get access to the account.",
    resetTotpConfirm: "Reset",
    totpResetDone: (name: string) => `Two-step verification reset for ${name}. They will register a new authenticator on their next sign-in.`,
    changeRoleLabel: (name: string) => `Role of ${name}`,
    roleChanged: (name: string) => `Role of ${name} changed.`,
    remove: "Remove",
    removeLabel: (name: string) => `Remove access for ${name}`,
    removeTitle: (name: string) => `Remove access for ${name}?`,
    removeDescription: "The person loses access to this organization immediately. The account still exists and can be invited again.",
    removed: (name: string) => `Access for ${name} removed.`,
    apiSub: "For integrations with RMM, PSA and scripts. The full token is shown only once.",
    createToken: "Create token",
    tokenName: "Name",
    tokenNameHint: "Where the token will be used. For example: HQ RMM.",
    tokenDefaultName: "Integration",
    validity: "Validity",
    days: (n: number) => `${n} days`,
    tokenCreatedTitle: "Save the token now",
    tokenSecretHint: "This is the only time the full token is shown. Store it in a password vault.",
    tokenSecretLabel: "API token",
    tokenUsage: "Send it in the header of every request:",
    colPrefix: "Prefix",
    colCreatedBy: "Created by",
    colLastUsed: "Last used",
    colExpires: "Expires",
    expired: "Expired",
    noTokens: "No API tokens yet.",
    revokeTokenLabel: (name: string) => `Revoke token ${name}`,
    revokeTokenTitle: (name: string) => `Revoke token ${name}?`,
    revokeTokenDescription: "Integrations that use this token stop working immediately.",
    tokenRevoked: "Token revoked.",
    colWhen: "When",
    colWho: "Who",
    colWhat: "What",
    colTarget: "Target",
    colIp: "IP",
  },
  es: {
    tabNotifications: "Notificaciones",
    tabCredentials: "Credenciales",
    notificationsSub: "Las alertas se envían cuando se abren y cuando se resuelven, nunca se repiten en cada verificación.",
    emailUnavailable: "El envío de correo no está configurado en este servidor. Los webhooks siguen disponibles.",
    newChannel: "Nuevo canal",
    editChannel: (name: string) => `Editar ${name}`,
    noChannels: "Todavía no hay canales de notificación. Sin canales, las alertas solo aparecen en la consola.",
    kind: "Tipo",
    kindEmail: "Correo",
    kindWebhook: "Webhook",
    destination: "Destino",
    minSeverity: "Gravedad",
    severityWarning: "Avisos y críticas",
    severityCritical: "Solo críticas",
    channelLanguage: "Idioma",
    channelEnabled: "Activo",
    channelDisabled: "En pausa",
    lastDelivery: "Última entrega",
    channelLastError: (msg: string) => `La última entrega falló: ${msg}`,
    testChannel: "Probar",
    testSent: "Notificación de prueba entregada.",
    deleteChannelLabel: (name: string) => `Quitar el canal ${name}`,
    deleteChannelTitle: (name: string) => `¿Quitar el canal ${name}?`,
    deleteChannelDescription: "Las notificaciones pendientes de este canal se descartan. Las alertas siguen visibles en la consola.",
    channelDeleted: "Canal quitado.",
    channelSaved: "Canal guardado.",
    channelName: "Nombre",
    channelNamePlaceholder: "Equipo de soporte",
    emailsLabel: "Correos",
    emailsHint: "Uno por línea o separados por coma, hasta 20.",
    webhookUrl: "Dirección del webhook",
    webhookUrlHint: "Debe ser https://. El servidor no sigue redirecciones.",
    enabledLabel: "Canal activo",
    monthlySummaryLabel: "Enviar el resumen mensual de protección",
    monthlySummaryHint: "El día 1, el resumen del mes anterior llega por correo con el informe en PDF/A adjunto. El botón de informe de la lista lo envía ahora, para validar.",
    monthlySummaryTag: "Resumen mensual",
    sendSummary: (name: string) => `Enviar ahora el resumen del mes anterior por ${name}`,
    summarySent: "Resumen mensual enviado. La emisión está en Informes.",
    webhookSecretTitle: "Guarda el secreto del webhook",
    webhookSecretHint: "Este secreto solo se muestra ahora. Úsalo para verificar que las llamadas vienen de E-BACKUP.",
    webhookSecretLabel: "secreto del webhook",
    webhookVerify: "Cada llamada incluye X-EBackup-Timestamp y X-EBackup-Signature. La firma es sha256= seguido del HMAC-SHA256, con este secreto, de timestamp + \".\" + cuerpo. Rechaza las llamadas con timestamp antiguo.",
    title: "Configuración",
    lede: "Acceso a la consola y a la API, y el registro de auditoría de esta organización.",
    accountTitle: "Tu cuenta",
    languageHint: "Se guarda en tu cuenta y se aplica en cualquier navegador.",
    passwordLabel: "Contraseña",
    passwordHint: "Al cambiarla, se cierran las demás sesiones abiertas con tu cuenta.",
    changePassword: "Cambiar contraseña",
    currentPassword: "Contraseña actual",
    newPassword: "Nueva contraseña",
    newPasswordHint: "De 12 a 256 caracteres. Una frase larga es más segura que una contraseña corta y complicada.",
    confirmPassword: "Repite la nueva contraseña",
    mismatch: "Las contraseñas no coinciden.",
    code: "Código de la app de autenticación",
    passwordChanged: "Contraseña cambiada. Se cerraron tus demás sesiones.",
    nameHint: "Se muestra a las personas de tus organizaciones y en el registro de auditoría.",
    editName: "Cambiar nombre",
    nameSaved: "Nombre guardado.",
    emailHint: "Se usa para iniciar sesión y para restablecer la contraseña. Cambiarlo requiere la contraseña actual y el código de la app de autenticación.",
    changeEmail: "Cambiar correo",
    changeEmailDescription: "Confirma con tu contraseña actual y el código de la app de autenticación. Si este servidor envía correos, el cambio solo se aplica después de abrir el enlace enviado a la nueva dirección.",
    newEmail: "Nuevo correo electrónico",
    emailPendingTitle: "Confirma tu nuevo correo",
    emailPending: (email: string) => `Enviamos un enlace de confirmación a ${email}. El cambio solo se aplica después de abrir el enlace, que vence en 1 hora. Mientras tanto, sigue iniciando sesión con tu correo actual.`,
    emailPendingNotice: "Tu dirección actual también recibió un aviso sobre esta solicitud.",
    emailChanged: (email: string) => `Correo cambiado a ${email}.`,
    mockConfirmEmail: "Abrir el enlace de confirmación (mock)",
    actionFailed: "No se pudo completar. Inténtalo de nuevo.",
    tabs: "Configuración",
    tabUsers: "Usuarios",
    tabApi: "Tokens de API",
    tabAudit: "Auditoría",
    usersSub: "Todas las cuentas usan verificación en dos pasos.",
    invite: "Invitar persona",
    inviteDescription: "La persona recibe un enlace de un solo uso, válido por 72 horas, para crear su cuenta con verificación en dos pasos.",
    email: "Correo electrónico",
    name: "Nombre",
    role: "Rol",
    roleHint: {
      org_admin: "Todo, incluidas personas, políticas y tokens de API.",
      operator: "Inicia copias de seguridad y restauraciones; no cambia la configuración.",
      viewer: "Solo consulta.",
    },
    createInvite: "Crear invitación",
    inviteCreatedTitle: "Invitación creada",
    inviteLinkHint: (email: string) => `Envía este enlace a ${email} por un canal seguro. Solo se muestra ahora y es válido por 72 horas.`,
    inviteLinkLabel: "enlace de la invitación",
    done: "Listo",
    pendingTitle: "Invitaciones pendientes",
    expiresIn: (when: string) => `vence ${when}`,
    invitedBy: (who: string) => `invitado por ${who}`,
    revoke: "Revocar",
    invitationRevoked: "Invitación revocada.",
    colName: "Nombre",
    colRole: "Rol",
    colTwoStep: "Dos pasos",
    colLastLogin: "Último acceso",
    inherited: "heredado del MSP",
    you: "tú",
    twoStepOn: "Activa",
    twoStepPending: "Autenticación pendiente",
    actions: "Acciones",
    resetTotpLabel: (name: string) => `Restablecer la verificación en dos pasos de ${name}`,
    resetTotpTitle: (name: string) => `¿Restablecer la verificación en dos pasos de ${name}?`,
    resetTotpDescription: "Úsalo cuando la persona perdió o cambió su teléfono. Antes, confirma su identidad por un canal de confianza.",
    resetTotpSessions: "Todas sus sesiones abiertas se cierran de inmediato, en cualquier navegador.",
    resetTotpNextLogin: "En su próximo inicio de sesión, después de la contraseña, verá un código QR para registrar una nueva app de autenticación.",
    resetTotpPassword: "Su contraseña no cambia, y tú no obtienes acceso a la cuenta.",
    resetTotpConfirm: "Restablecer",
    totpResetDone: (name: string) => `Verificación en dos pasos de ${name} restablecida. Registrará una nueva app de autenticación en su próximo inicio de sesión.`,
    changeRoleLabel: (name: string) => `Rol de ${name}`,
    roleChanged: (name: string) => `Rol de ${name} cambiado.`,
    remove: "Quitar",
    removeLabel: (name: string) => `Quitar el acceso de ${name}`,
    removeTitle: (name: string) => `¿Quitar el acceso de ${name}?`,
    removeDescription: "La persona pierde el acceso a esta organización de inmediato. La cuenta sigue existiendo y se puede invitar de nuevo.",
    removed: (name: string) => `Acceso de ${name} quitado.`,
    apiSub: "Para integraciones con RMM, PSA y scripts. El token completo se muestra una sola vez.",
    createToken: "Crear token",
    tokenName: "Nombre",
    tokenNameHint: "Dónde se usará el token. Por ejemplo: RMM de la oficina central.",
    tokenDefaultName: "Integración",
    validity: "Validez",
    days: (n: number) => `${n} días`,
    tokenCreatedTitle: "Guarda el token ahora",
    tokenSecretHint: "Es la única vez que se muestra el token completo. Guárdalo en un gestor de contraseñas.",
    tokenSecretLabel: "token de API",
    tokenUsage: "Envíalo en el encabezado de cada solicitud:",
    colPrefix: "Prefijo",
    colCreatedBy: "Creado por",
    colLastUsed: "Último uso",
    colExpires: "Vence",
    expired: "Vencido",
    noTokens: "Todavía no hay tokens de API.",
    revokeTokenLabel: (name: string) => `Revocar el token ${name}`,
    revokeTokenTitle: (name: string) => `¿Revocar el token ${name}?`,
    revokeTokenDescription: "Las integraciones que usan este token dejan de funcionar de inmediato.",
    tokenRevoked: "Token revocado.",
    colWhen: "Cuándo",
    colWho: "Quién",
    colWhat: "Qué",
    colTarget: "Destino",
    colIp: "IP",
  },
});
